import ComponentsLoader from "./core/components-loader";
import pinia from "./core/pinia";
import EditorIframeApiService from "./services/editor-iframe-api.service";
import { useConfigStore } from "./stores";
import type { ComponentsMap } from "./types/component";
import type { IUpdateConfigState } from "./types/store-states.types";

const componentsMap: ComponentsMap = import.meta.glob('../src/views/*.vue', { eager: false }) as ComponentsMap;

class FlowApp {
  public static useShadowRoot: boolean = true;
  private componentsLoader: ComponentsLoader;
  private componentsTagName: string[] = [];

  constructor() {
    if (!componentsMap) {
      throw new Error('Components not found');
    }
    this.componentsLoader = new ComponentsLoader(
      componentsMap,
      FlowApp.useShadowRoot
    );
  }

  public async init(config: any) {
    return await this.asyncLoadModules().then(() => {
      this.configuring(config);
      this.componentsTagName = this.componentsLoader.initComponents();
    }).finally(() => {
      return this.componentsTagName;
    });
  }

  public async preloadEditor(designEditorUrl: string | null, loadHandler: () => void) {
    const editorIframeApiService = new EditorIframeApiService();
    if (EditorIframeApiService.status.value === null) {
      return await editorIframeApiService.load(designEditorUrl, null, loadHandler);
    } 
  }

  private async asyncLoadModules() {
    return await Promise.all(
      await this.componentsLoader.loadingModules()
    );
  }

  private configuring(config: IUpdateConfigState) {
    const configStore = useConfigStore(pinia);
    configStore.updateConfig(config);
  }

}

// @ts-ignore
window.flowApp = FlowApp;